import { useEffect, useState, useRef } from "react";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"
import { stateDevice,stateNavigation } from "../store";
import "../style.css";
import { useSnapshot } from "valtio";

export default function SlidebarImageGalleryBig({currentGalerie, currentIndex, onIndexChange}) {
  const sliderRef = useRef(null);
  const [ready, setReady] = useState(false);
  const [direction, setDirection] = useState("right");
  const snapStateNavigation = useSnapshot(stateNavigation)
  const snapStateDevice = useSnapshot(stateDevice)

  // Reset gallery on change
  useEffect(() => {
    setReady(false);
    const timeout = setTimeout(() => {
      setReady(true);
      sliderRef.current?.resetTransform();
    }, 0);
    return () => clearTimeout(timeout);
  }, [currentGalerie]);

  const prevSlide = () => {
    setDirection("left");
    const isFirst = currentIndex === 0;
    const newIndex = isFirst ? currentGalerie.length - 1 : currentIndex - 1;
    onIndexChange(newIndex);
    sliderRef.current?.resetTransform();
  };

  const nextSlide = () => {
    setDirection("right");
    const isLast = currentIndex === currentGalerie.length - 1;
    const newIndex = isLast ? 0 : currentIndex + 1;
    onIndexChange(newIndex);
    sliderRef.current?.resetTransform();
  };

  return (

      
     <div className=" flex flex-col items-center justify-center h-full w-full group  ">
        <TransformWrapper
          ref={sliderRef}
          initialScale={1}
          minScale={1}
          maxScale={4}
          wheel={{ disabled: true }}
          pinch={{ disabled: false }}
          doubleClick={{ disabled: false }}
        >
          <TransformComponent>
            {ready && currentGalerie[currentIndex] && (
              <img
                key={currentIndex} // triggers animation re-render
                src={currentGalerie[currentIndex]}
                alt=""
                className={`object-contain h-[60vh] rounded-xl opacity-0 animate-slide-in`}
                style={{
                  animationName: direction === "right" ? "slideInRight" : "slideInLeft",
                  animationDuration: "0.7s",
                  animationFillMode: "forwards",
                }}
              />
            )}
          </TransformComponent>
        </TransformWrapper>

        {/* Left Arrow */}
        {currentGalerie.length > 1 && (
  <>
    {/* Left Arrow — mx-20 rückt die Pfeile auf schmalen Portrait-Screens tief
        in die Bildmitte, dort nur leicht Luft zum Rand (mx-2). */}
    <div
      className="font-roboto absolute top-1/2 -translate-y-1/2 left-0 text-2xl mx-20 mobilePortrait:mx-2 rounded-full p-2 bg-black/40 text-white cursor-pointer flex items-center justify-center hover:bg-black/60"
      onClick={prevSlide}
    >
      <BsChevronCompactLeft size={25} />
    </div>

    {/* Right Arrow */}
    <div
      className="absolute top-1/2 -translate-y-1/2 right-0 text-2xl mx-20 mobilePortrait:mx-2 rounded-full p-2 bg-black/40 text-white cursor-pointer flex items-center justify-center hover:bg-black/60"
      onClick={nextSlide}
    >
      <BsChevronCompactRight size={25} />
    </div>
  </>
)}
      </div>

  
  );
}
